import { Image, SundaeSwapLogo, toolkitCx } from "@sundae/ui-toolkit";
import cx from "classnames";
import { FC } from "react";
import { useTasteTestContext } from "../../../pages/TasteTestDetail/context";

const TasteTestPfp: FC = () => {
  const {
    state: { tasteTestPersonalization },
  } = useTasteTestContext();

  return (
    <div className="relative z-10 flex justify-between">
      <div
        className={cx(
          "group absolute -mt-12 h-24 w-24 flex-shrink-0 overflow-hidden rounded-full xl:-mt-14 xl:h-28 xl:w-28",
          toolkitCx.layout.border.weight.bold,
          {
            "flex items-center justify-center": !!tasteTestPersonalization?.pfpImage,
            [toolkitCx.layout.background.default]: !!tasteTestPersonalization?.pfpImage,
            "border-white dark:border-gray-900": !!tasteTestPersonalization?.secondaryColor,
          }
        )}
        style={{
          backgroundColor: tasteTestPersonalization?.secondaryColor || undefined,
          borderColor: tasteTestPersonalization?.secondaryColor || "",
        }}
      >
        {tasteTestPersonalization?.pfpImage ? (
          <Image
            src={tasteTestPersonalization.pfpImage}
            className={cx(
              "h-full w-full object-cover object-center group-hover:scale-105",
              toolkitCx.layout.transition.transform
            )}
          />
        ) : (
          <SundaeSwapLogo
            className={cx(
              "h-12 w-12 object-cover object-center group-hover:scale-105 lg:h-14 lg:w-14",
              toolkitCx.layout.transition.transform
            )}
          />
        )}
      </div>
    </div>
  );
};

export default TasteTestPfp;
